import type { RootState } from 'src/store';
import type { AppAction } from 'src/store/actions';

export const combineReducersFlat =
    <T = Partial<RootState>>(reducers: ((state: T, action: AppAction) => T)[]) =>
    (state: T, action: AppAction) =>
        reducers.reduce((newState, reducer) => reducer(newState, action), state);
